exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-e2fa4b8c]{margin:14px}.iframe[data-v-e2fa4b8c]{width:100%;height:calc(100vh - 85px);border:none}.box[data-v-e2fa4b8c]::-webkit-scrollbar{height:0;width:0}\n", ""]);

// exports
